import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import UseContext from '../../../../../hooks/useContext';
import ApiDatabase from '../../../../../server';
import Button from '../../../../button';
import StyledInput from '../../../../styledInput/StyledInput';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import Modalheader from '../../../components/header';
import useModal from '../../../useModal';

const ModalCompanyPostIt = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isWaiting, setIsWaiting] = useState(true);
  const [content, setContent] = useState('');

  const token = localStorage.getItem('xsrfToken');

  const handleSubmit = () => {
    if (!modalData?.idCompany) return;
    setIsLoading(true);
    ApiDatabase.postPostItCompany(
      { token, idCompany: modalData.idCompany, content },
      (data) => {
        setIsLoading(false);
        toast.success('Le post-it a bien été enregistré');
        setModalDataReturn({
          type: 'company_post_it_updated',
          postIt: data.postIt,
        });
        toggle();
      },
      (err) => {
        if (err.name === 'CanceledError') return;
        setIsLoading(false);
        // The server rejects an over-long note with { error, errorCode };
        // anything else is not worth spelling out to the user.
        const message = err?.response?.data?.error;
        toast.error(message || "L'enregistrement a échoué");
      },
    );
  };

  useEffect(() => {
    if (!modalData?.idCompany) {
      setIsWaiting(false);
      return;
    }

    ApiDatabase.getPostItCompany(
      { token, idCompany: modalData.idCompany },
      (data) => {
        setContent(data.postIt ?? '');
        setIsWaiting(false);
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          console.error(err);
          setIsWaiting(false);
        }
      },
    );
  }, [modalData?.idCompany]);

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Post-it
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-2.5 text-sm">
          {isWaiting ? (
            <div className={'animate-pulse'}>
              <div className={'h-32 bg-gray-200 rounded w-full'}></div>
            </div>
          ) : (
            <>
              <div className={'text-gray-500'}>
                Cette consigne s’affiche sur le détail de relevé d’heures et la
                vue contrat de la mission. Elle n’est modifiable que d’ici.
              </div>
              <StyledInput
                type={'textarea'}
                label={'Contenu'}
                value={content}
                placeholder={'Particularité de saisie, contact à prévenir…'}
                onChange={(e) => setContent(e.target.value)}
              />
              {/* Vider le champ est la façon de supprimer le post-it : pas de
                  bouton dédié pour une action que le champ exprime déjà. */}
              <div className={'text-gray-500'}>
                Videz le champ pour retirer le post-it.
              </div>
            </>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        {isLoading ? (
          <>
            <Button size={'LG'} color={'SECONDARY'}>
              Annuler
            </Button>
            <Button size={'LG'} color={'DISABLED'}>
              Confirmation ...
            </Button>
          </>
        ) : (
          <>
            <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
              Annuler
            </Button>
            <Button size={'LG'} color={'PRIMARY'} onClick={handleSubmit}>
              Confirmer
            </Button>
          </>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalCompanyPostIt;
